import { IHttpApi } from '@cian/http-api';
import { HttpBadStatusCodeError } from '@cian/peperrors/shared';

import {
  TCianApiSiteV1GetBsCenterInfoResponse,
  fetchCianApiSiteV1GetBsCenterInfo,
} from 'shared/repositories/monolith-python/cian-api/site/v1/get-bs-center-info';
import { IBSCenterSchema } from 'shared/repositories/monolith-python/entities/schemas/BSCenterSchema';
import { extractUndefined } from 'shared/utils/extractUndefined';

import { TCommercialClass } from '../types/commercial';

export interface IBSCenterInfo {
  buildYear?: string;
  buildingClassType: TCommercialClass;
  buildingType: string;
  fullAddress: string;
  fullUrlDefaultFoto: string;
  id: number;
  name: string;
  offersRentCount: number;
  offersRentLink: string;
  offersSaleCount: number;
  offersSaleLink: string;
  primaryOfficialRepresentativeAgent?: IOfficialRepresentativeAgent;
  seoCityName: string;
  totalArea: string;
  underground: string;
  url: string;
}

export interface IOfficialRepresentativeAgent {
  id: number;
  avatarUrl?: string;
  name: string;
  phones?: IPrimaryOfficialRepresentativeAgentPhone[];
  userId?: number;
  visiblePhones?: IPrimaryOfficialRepresentativeAgentPhone[];
}

export interface IPrimaryOfficialRepresentativeAgentPhone {
  code: string;
  confirmed: boolean;
  countryCode: string;
  id: number;
  number: string;
  visible: boolean;
}

type GetBSCenterInfoOptions = {
  httpApi: IHttpApi;
  subdomain: string;
  id: number;
};

export function getBSCenterInfo({ httpApi, id, subdomain }: GetBSCenterInfoOptions): Promise<IBSCenterSchema | null> {
  return fetchCianApiSiteV1GetBsCenterInfo<
    TCianApiSiteV1GetBsCenterInfoResponse,
    TCianApiSiteV1GetBsCenterInfoResponse,
    TCianApiSiteV1GetBsCenterInfoResponse
  >({
    httpApi,
    parameters: {
      bsCenterId: id,
    },
    config: {
      subdomain,
    },
  })
    .then(({ response, statusCode }) => {
      switch (statusCode) {
        case 200:
          return extractUndefined(response.data.bsCenter);
        case 400:
        case 404:
          throw new HttpBadStatusCodeError({
            statusCode,
            domain: 'src/shared/api/bs_centers.ts',
          });
      }
    })
    .catch(ex => {
      if (HttpBadStatusCodeError.is(ex)) {
        if (ex.statusCode === 404) {
          return null;
        }
      }

      throw ex;
    });
}
